import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
// import axios from "axios";

const filterChapterFromCategory = require("../utilities/chapterlist");

class AllStagesTableByEnemies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enemyChapterFilters: [],
      // currCategory: "",
      // enemyFilteredInfo: null,
      // filteredCategory: "",
      // filteredChapter: null,
      enemyFilteredInfo: null,
    };

    this.hydrateStateWithLocalStorage = this.hydrateStateWithLocalStorage.bind(
      this
    );
  }

  hydrateStateWithLocalStorage() {
    // for all items in state
    for (let key in this.state) {
      // if the key exists in localStorage
      if (localStorage.hasOwnProperty(key)) {
        // get the key's value from localStorage
        let value = localStorage.getItem(key);
        try {
          value = JSON.parse(value);
          // this.setState({ [key]: value });
          this.setState({ [key]: value }, function () {
            // console.log(this.state);
          });
          // if (key === "selectedCats") {
          //   let selectedCats = value.map(function (cat, index) {
          //     var o = Object.assign({}, cat);
          //     o.key = index;
          //     // console.log(o);
          //     if (o.ability === null) {
          //       o.ability = " ";
          //     }
          //     return o;
          //   });

          //   this.setState({ selectedCats: selectedCats });
          // } else {
          //   this.setState({ [key]: value }, function () {
          //     // console.log(this.state);
          //   });
          // }
        } catch (e) {
          // handle empty string
          this.setState({ [key]: value });
        }
      }
    }
  }

  componentDidMount() {
    this.hydrateStateWithLocalStorage();

    // add event listener to save state to localStorage
    // when user leaves/refreshes the page
    document.title = "My Gamatoto | Battle Cats Wiki for Cat Stats";

    window.addEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );

    // axios
    //   .get("https://onestoppress.com/api/chapterlist")
    //   .then((res) => {
    //     let dataSource = res.data;
    //     this.setState({ chapterlist: dataSource });
    //     console.log(this.state.chapterlist);
    //   })
    //   .catch((err) => console.log("err: ", err));
  }

  saveStateToLocalStorage() {
    // for every item in React state
    for (let key in this.state) {
      // save to localStorage
      localStorage.setItem(key, JSON.stringify(this.state[key]));
    }
  }

  componentWillUnmount() {
    window.removeEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );

    // saves if component has a chance to unmount
    this.saveStateToLocalStorage();
  }

  handleChange = (pagination, filters, sorter) => {
    // console.log("Various parameters", filters, filteredValue);
    // console.log("filteredValue parameters", filters, filteredValue.category[0]);

    if (this.state.enemyFilteredInfo) {
      if (filters.category !== this.state.enemyFilteredInfo.category) {
        // console.log(filters.category);
        // console.log(this.state.enemyFilteredInfo.category);
        filters.chapter = null;
        this.setState({
          enemyFilteredInfo: filters,
          enemyChapterFilters: filterChapterFromCategory(filters.category[0]),
        });
        // console.log("cleared chapters due to category change");
        // console.log(filters.category);
        // console.log(filters.chapter);
      } else {
        this.setState({
          enemyFilteredInfo: filters,
          // enemyChapterFilters: filterChapterFromCategory(filters.category[0]),
          // filteredCategory: filters.category[0],
          // filteredChapter: filteredValue.chapter[0],
        });
        // console.log("no category change, updated enemyFilteredInfo");
        // console.log(filters.category);
        // console.log(filters.chapter);
      }
    } else {
      this.setState({
        enemyFilteredInfo: filters,
        enemyChapterFilters: filterChapterFromCategory(filters.category[0]),
        // enemyChapterFilters: filterChapterFromCategory(filters.category[0]),
        // filteredCategory: filters.category[0],
        // filteredChapter: filteredValue.chapter[0],
      });
      // console.log("no category change, updated enemyFilteredInfo");
      // console.log(filters.category);
      // console.log(filters.chapter);
    }
  };

  render() {
    // const innerHeight = this.props.viewportHeight;

    let { enemyFilteredInfo } = this.state;

    enemyFilteredInfo = enemyFilteredInfo || {};

    const columns = [
      {
        title: "Category",
        width: 140,
        dataIndex: "category",
        key: "category",
        align: "left",
        filters: [
          {
            text: "Stories of Legend",
            value: "Stories of Legend",
          },
          {
            text: "Uncanny Legends",
            value: "Uncanny Legends",
          },
          {
            text: "Legend Zero",
            value: "Legend Zero",
          },
          {
            text: "Story Mode",
            value: "Story Mode",
          },
          {
            text: "Collab",
            value: "Collab",
          },
          {
            text: "Regular Event Stages",
            value: "Regular event stages",
          },
          {
            text: "Heavenly Tower",
            value: "Heavenly Tower",
          },
          {
            text: "Enigma",
            value: "Enigma",
          },
          {
            text: "Baron Stages",
            value: "Baron Stages",
          },

          {
            text: "Collab Barons",
            value: "Collab Barons",
          },
          {
            text: "Zombie Outbreaks",
            value: "Zombie Outbreaks",
          },
          {
            text: "Dojo",
            value: "Dojo",
          },
          {
            text: "Extra",
            value: "Extra",
          },
          {
            text: "Challenge Battle",
            value: "Challenge Battle",
          },
          {
            text: "Filibuster Invasion",
            value: "Filibuster Invasion",
          },
        ],
        filteredValue: enemyFilteredInfo.category || null,
        onFilter: (value, record) => record.category === value,
        filterMultiple: false,
      },
      {
        title: "Chapter",
        width: 150,
        dataIndex: "chapter",
        key: "chapter",
        filters: this.state.enemyChapterFilters,
        filteredValue: enemyFilteredInfo.chapter || null,
        onFilter: (value, record) => record.chapter === value,
      },
      {
        title: "Stage",
        dataIndex: "stage",
        key: "stage",
        width: 150,
        align: "left",
        render: (text, record) => (
          <Link to={"/stageinfo/" + record.stageid + "/" + record.stage}>
            {record.stage}
          </Link>
        ),
      },
      {
        title: "Enemies",
        dataIndex: "enemies",
        key: "enemies",
        width: 300,
        align: "left",
        render: (text, record) => {
          // let enemies = [];
          // for (var key in record.enemies) {
          //   if (record.enemies.hasOwnProperty(key)) {

          //     if (enemies) {
          //       enemies.push(
          //         <div
          //           style={{
          //             overflow: "hidden",
          //             float: "left",
          //             textAlign: "center",
          //             maxWidth: "60px",
          //             textOverflow: "ellipsis",
          //             whiteSpace: "nowrap",
          //           }}
          //         >
          //           <Link to={"/enemyinfo/" + key + "/" + record.enemies[key]}>
          //             <div>
          //               <img
          //                 style={{
          //                   width: "40px",
          //                   marginBottom: "0px",
          //                 }}
          //                 src={
          //                   "https://onestoppress.com/images/enemy_icon_" +
          //                   key +
          //                   ".png"
          //                 }
          //                 alt={record.enemies[key]}
          //               />
          //             </div>
          //             {/* {record.enemies[key]} */}
          //           </Link>
          //         </div>
          //       );
          //     }
          //   }
          // }

          let enemies = record.enemies.map((enemy) => {
            return (
              <div
                style={{
                  overflow: "hidden",
                  float: "left",
                  textAlign: "center",
                  maxWidth: "60px",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <Link
                  to={
                    "/enemyinfo/" +
                    enemy.enemy_no +
                    "/" +
                    enemy.enemy_name +
                    "/" +
                    enemy.enemy_multiplier
                  }
                >
                  <div>
                    <img
                      style={{
                        width: "40px",
                        marginBottom: "0px",
                      }}
                      src={
                        "https://onestoppress.com/images/enemy_icon_" +
                        enemy.enemy_no +
                        ".png"
                      }
                      alt={enemy.enemy_name}
                    />
                  </div>
                </Link>
              </div>
            );
          });

          return <div>{enemies}</div>;
        },
      },
      {
        title: "Energy",
        dataIndex: "energy",
        key: "energy",
        width: 85,
        align: "left",
        sorter: (a, b) => a.energy - b.energy,
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={this.props.selectedStages}
        scroll={{ x: 400 }}
        onChange={this.handleChange}
        size="small"
        loading={false}
        locale={{
          emptyText: (
            <div>
              View all battle cats stages and search for stages by the enemies
              that appear!
              <p></p>
              From Empire of Cats to Stories of Legend to Heavenly Tower and
              more, find them all here!
              <p></p>
              Note: Stages can take a while to load for the first time.
            </div>
          ),
        }}
        pagination={{
          position: "bottom",
          hideOnSinglePage: true,
          showQuickJumper: true,
          showSizeChanger: true,
          defaultPageSize: 50,
          pageSizeOptions: ["25", "50", "100", "600"],
        }}
      />
    );
  }
}

export default AllStagesTableByEnemies;



// WEBPACK FOOTER //
// ./src/components-kr/table/AllStagesTableByEnemies.js